<template>
  <div>
    <SidebarVue ref="sidebar" />
    <NavgatorDk
      ref="navgator"
      :barraTitulo="' Situação Geral Lojas - Desk'"
      :titulo="'situação geral'"
    />

    <div class="dashboard-bi">
      <!-- Filtros (mantido igual) -->
      <div class="card filter-container">
        <div class="row g-2 p-2">
          <div
            class="card-title gy-4 d-flex align-items-center justify-content-between"
          >
            <div class="d-flex align-items-center">
              <i class="bi bi-funnel fs-5 icon-text-form"></i>
              <span class="txt-title-form ms-2">Parâmetros do Relatório</span>
            </div>
            <button
              class="btn btn-filtro d-inline-flex align-items-center"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#biFilters"
              aria-expanded="true"
              aria-controls="biFilters"
              style="max-width: 40px"
            >
              <i class="bi bi-chevron-down"></i>
            </button>
          </div>

          <div class="params-row">
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <select
                  v-model="selectedTipoLoja"
                  @change="getEmpresas()"
                  class="form-select txt-form-input"
                >
                  <option value="1">Quatro Rodas</option>
                  <option value="2">Duas Rodas</option>
                </select>
                <label class="param-label">Tipo de Loja</label>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <select
                  v-model="selectedFilter"
                  @change="filtarRelatorios()"
                  class="form-select txt-form-input"
                >
                  <option value="hoje">Hoje</option>
                  <option value="ontem">Ontem</option>
                  <option value="mes_atual">Mês Atual</option>
                  <option value="mes_anterior">Mês Anterior</option>
                  <option value="personalizado">Personalizado</option>
                </select>
                <label class="param-label">Referência</label>
              </div>
            </div>

            <div class="col-12 col-md-3">
              <div v-if="selectedFilter === 'personalizado'">
                <div class="form-floating txt-form-label input-group">
                  <input
                    type="date"
                    v-model="startDate"
                    class="form-control txt-form-input"
                  />
                  <span class="input-group-text">até</span>
                  <input
                    type="date"
                    v-model="endDate"
                    class="form-control txt-form-input"
                  />
                </div>
              </div>
            </div>
            <div class="col-2">
              <div class="form-group">
                <button class="btn round-btn" @click="propostas_mes">
                  <i class="bi bi-search" title="Pesquisar"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Filtro Lojas (mantido igual) -->
      <div class="card filter-container">
        <div class="row g-2 p-2">
          <div
            class="card-title gy-4 d-flex align-items-center justify-content-between"
          >
            <div class="d-flex align-items-center">
              <i class="bi bi-shop fs-5 icon-text-form"></i>
              <span class="txt-title-form ms-2">Lojas</span>
            </div>
            <button
              class="btn btn-filtro d-inline-flex align-items-center"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#biFiltersLojas"
              aria-expanded="true"
              aria-controls="biFiltersLojas"
              style="max-width: 40px"
            >
              <i class="bi bi-chevron-down"></i>
            </button>
          </div>
        </div>
        <div class="collapse show" id="biFiltersLojas">
          <div class="select-all mb-3">
            <div class="col-12 col-md-1 col-lg-1">
              <input
                class="btn-check"
                type="checkbox"
                id="checkboxTodos"
                v-model="marcarTodos"
                autocomplete="off"
              />
              <label class="btn btn-avaliacao" for="checkboxTodos"
                >Marcar Todos</label
              >
            </div>
            <div class="d-flex flex-wrap gap-2 align-items-center">
              <div
                v-for="item in lista_empresas"
                :key="'emp_' + item.id"
                class="filter-item-single-line"
              >
                <input
                  type="checkbox"
                  :id="'emp_' + item.id"
                  :value="item.id"
                  v-model="selectedEmpresas"
                  @click.stop
                  class="filter-checkbox"
                />
                <label :for="'emp_' + item.id" class="filter-label">
                  <span class="filter-icon"
                    ><i class="bi bi-building"></i
                  ></span>
                  <span class="filter-text">{{ item.nome }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- LINHA 1: KPIs PRINCIPAIS -->
      <!-- <div class="row mb-3">
        <div class="col-12 p-1">
          <div class="card section-card">
            <div class="card-header bg-white">
              <h5 class="mb-0">
                <i class="bi bi-graph-up me-2"></i>
                Painel de Métricas
              </h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-3 mb-2 mb-md-0">
                  <div class="kpi-card-v2 text-center p-3">
                    <div class="kpi-icon-circle bg-primary-light mx-auto mb-2">
                      <i class="bi bi-percent fs-4 text-primary"></i>
                    </div>
                    <h2 class="mb-0">
                      {{ formatPercentValue(taxa_conversao) }}
                    </h2>
                    <p class="text-muted mb-0 small">Taxa de Conversão</p>
                    <small class="text-success">↑ Meta: 50%</small>
                  </div>
                </div>
                <div class="col-md-3 mb-2 mb-md-0">
                  <div class="kpi-card-v2 text-center p-3">
                    <div class="kpi-icon-circle bg-success-light mx-auto mb-2">
                      <i class="bi bi-check2-circle fs-4 text-success"></i>
                    </div>
                    <h2 class="mb-0">
                      {{ formatPercentValue(aproveitamento) }}
                    </h2>
                    <p class="text-muted mb-0 small">Aproveitamento</p>
                    <small class="text-muted">Oportunidades</small>
                  </div>
                </div>
                <div class="col-md-3 mb-2 mb-md-0">
                  <div class="kpi-card-v2 text-center p-3">
                    <div class="kpi-icon-circle bg-danger-light mx-auto mb-2">
                      <i class="bi bi-x-circle fs-4 text-danger"></i>
                    </div>
                    <h2 class="mb-0">{{ formatPercentValue(taxa_perda) }}</h2>
                    <p class="text-muted mb-0 small">Taxa de Perda</p>
                    <small class="text-danger">⚠ Atenção</small>
                  </div>
                </div>
                <div class="col-md-3 mb-2 mb-md-0">
                  <div class="kpi-card-v2 text-center p-3">
                    <div class="kpi-icon-circle bg-warning-light mx-auto mb-2">
                      <i class="bi bi-trophy fs-4 text-warning"></i>
                    </div>
                    <h2 class="mb-0">{{ eficiencia_comercial }}</h2>
                    <p class="text-muted mb-0 small">Eficiência Comercial</p>
                    <small class="text-muted">Pontuação</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- LINHA 2: FUNIL DE VENDAS (NOVO VISUAL) -->
      <div class="row mb-3">
        <div class="col-md-8 p-1">
          <div class="card section-card h-100">
            <div class="card-header bg-white">
              <h5 class="mb-0">
                <i class="bi bi-funnel me-2"></i>
                Funil de Vendas Consolidado
              </h5>
            </div>
            <div class="card-body">
              <div class="funnel-container">
                <div class="funnel-step">
                  <div
                    class="d-flex justify-content-between align-items-center mb-1"
                  >
                    <span
                      ><i class="bi bi-people-fill text-primary me-2"></i
                      >Passagens</span
                    >
                    <strong class="text-primary">{{
                      total_passagem_zero + total_passagem_usado
                    }}</strong>
                  </div>
                  <div class="progress" style="height: 8px">
                    <div
                      class="progress-bar bg-primary-subtle"
                      style="width: 100%"
                    ></div>
                  </div>
                </div>
                <div class="funnel-step mt-3">
                  <div
                    class="d-flex justify-content-between align-items-center mb-1"
                  >
                    <span
                      ><i class="bi bi-clock-history text-warning me-2"></i>Em
                      Atendimento</span
                    >
                    <strong class="text-warning">{{
                      total_em_atendimento_zero + total_em_atendimento_usados
                    }}</strong>
                  </div>
                  <div class="progress" style="height: 8px">
                    <div
                      class="progress-bar bg-warning-subtle"
                      :style="{ width: taxa_atendimento_percent }"
                    ></div>
                  </div>
                  <small class="text-muted"
                    >{{ formatPercentValue(taxa_atendimento) }} do total</small
                  >
                </div>
                <div class="funnel-step mt-3">
                  <div
                    class="d-flex justify-content-between align-items-center mb-1"
                  >
                    <span
                      ><i class="bi bi-check-circle-fill text-success me-2"></i
                      >Vendas Realizadas</span
                    >
                    <strong class="text-success">{{
                      total_vendas_finalizadas_zero +
                      total_vendas_finalizadas_usado
                    }}</strong>
                  </div>
                  <div class="progress" style="height: 8px">
                    <div
                      class="progress-bar bg-success-subtle"
                      :style="{ width: taxa_conversao_percent }"
                    ></div>
                  </div>
                  <small class="text-muted"
                    >{{ formatPercentValue(taxa_conversao) }} de
                    conversão</small
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 p-1">
          <div class="card section-card h-100">
            <div class="card-header bg-white">
              <h5 class="mb-0">
                <i class="bi bi-pie-chart me-2"></i>
                Composição de Clientes
              </h5>
            </div>
            <div class="text-center mb-3">
              <div class="composicao-chart d-inline-block position-relative">
                <canvas
                  id="composicaoChart"
                  width="180"
                  height="180"
                  style="max-width: 180px; max-height: 180px"
                ></canvas>
                <div
                  class="position-absolute top-50 start-50 translate-middle text-center"
                >
                  <small class="d-block text-muted">Total</small>
                  <strong>{{
                    total_passagem_zero + total_passagem_usado
                  }}</strong>
                </div>
              </div>
            </div>
            <div class="row text-center">
              <div class="col-6">
                <div class="badge-novos p-2 rounded">
                  <i class="bi bi-person-plus text-success"></i>
                  <span class="d-block fw-bold">{{
                    formatPercentValue(percentual_novos_geral)
                  }}</span>
                  <small class="text-muted">Clientes Novos</small>
                </div>
              </div>
              <div class="col-6">
                <div class="badge-retorno p-2 rounded">
                  <i class="bi bi-arrow-return-left text-warning"></i>
                  <span class="d-block fw-bold">{{
                    formatPercentValue(percentual_retorno_geral)
                  }}</span>
                  <small class="text-muted">Clientes Retorno</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- LINHA 3: COMPARATIVO ZERO KM VS USADOS (COM N/R DETALHADO) -->
      <div class="row mb-3">
        <!-- Zero KM -->
        <div class="col-md-6 p-1">
          <div class="card section-card h-100">
            <div class="card-header bg-white">
              <h5 class="mb-0">
                <i class="bi bi-car-front me-2 text-primary"></i>
                Veículos Zero KM
              </h5>
            </div>
            <div class="card-body">
              <!-- Métricas principais -->
              <div class="row text-center mb-3">
                <div class="col-3">
                  <div class="stat-box p-2 bg-primary-subtle">
                    <i
                      class="bi bi-box-arrow-in-down d-block mb-1"
                    ></i>
                    <h6 class="text-muted fw-bold">Passagens</h6>
                    <h3 class="mb-0">{{ total_passagem_zero }}</h3>
                    <div class="d-flex justify-content-center gap-2 small mt-1">
                      <h5 class="text-muted"
                        ><i class="bi bi-person-plus m-2"></i>
                        {{ total_passagem_zero_novas }}</h5
                      >
                      <h5 class="text-muted"
                        ><i class="bi bi-arrow-return-left m-2"></i>
                        {{ total_passagem_zero_retorno }}</h5
                      >
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="stat-box p-2 bg-secondary-subtle">
                    <i
                      class="bi bi-clock-history d-block mb-1"
                    ></i>
                    <h6 class="text-muted fw-bold">Atendimento</h6>
                    <h3 class="mb-0">{{ total_em_atendimento_zero }}</h3>
                    <h6 class="text-muted"
                      >{{
                        formatPercent(total_em_atendimento_zero_porcentagem)
                      }}%</h6
                    >
                    <div class="d-flex justify-content-center gap-2 small mt-1">
                      <h5 class="text-muted"
                        ><i class="bi bi-person-plus m-2"></i
                        >{{ total_em_atendimento_zero_novos }}</h5
                      >
                      <h5 class="text-muted"
                        ><i class="bi bi-arrow-return-left m-2"></i
                        >{{ total_em_atendimento_zero_retorno }}</h5
                      >
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="stat-box p-2 bg-danger-subtle">
                    <i class="bi bi-x-octagon d-block mb-1"></i>
                    <h6 class="text-muted fw-bold">Vendas Perdidas</h6>
                    <h3 class="mb-0">
                      {{ total_vendas_perdidas_zero }}
                    </h3>
                    <h6 class="text-muted"
                      >{{
                        formatPercent(total_vendas_perdidas_zero_porcentagem)
                      }}%</h6
                    >
                    <div class="d-flex justify-content-center gap-2 small mt-1">
                      <h5 class="text-muted"
                        ><i class="bi bi-person-plus m-2"></i
                        >{{ total_vendas_perdidas_zero_novos }}</h5
                      >
                      <h5 class="text-muted"
                        ><i class="bi bi-arrow-return-left m-2"></i
                        >{{ total_vendas_perdidas_zero_retorno }}</h5
                      >
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="stat-box p-2 bg-success-subtle">
                    <i class="bi bi-check-lg d-block mb-1"></i>
                    <h6 class="text-muted fw-bold">Vendas Efetuadas</h6>
                    <h3 class="mb-0">
                      {{ total_vendas_finalizadas_zero }}
                    </h3>
                    <h6 class="text-muted"
                      >{{
                        formatPercent(
                          total_vendas_finalizadas_zero_porcentagem
                        )
                      }}%</h6
                    >
                    <div class="d-flex justify-content-center gap-2 small mt-1">
                      <h5 class="text-muted"
                        ><i class="bi bi-person-plus m-2"></i
                        >{{ total_vendas_finalizadas_zero_novos }}</h5
                      >
                      <h5 class="text-muted"
                        ><i class="bi bi-arrow-return-left m-2"></i
                        >{{ total_vendas_finalizadas_zero_retorno }}</h5
                      >
                    </div>
                  </div>
                </div>
              </div>

              <!-- Lucros do segmento -->
              <hr class="my-2" />
              <!-- <div class="row text-center">
                <div class="col-3">
                  <small class="text-muted">Lucro Operacional</small>
                  <div class="fw-bold text-primary">
                    {{ fmtBRL(total_lucro_operacional_veiculos_novos) }}
                  </div>
                </div>
                <div class="col-3">
                  <small class="text-muted">Lucro Gerencial</small>
                  <div class="fw-bold">
                    {{ fmtBRL(total_lucro_gerencial_veiculos_novos) }}
                  </div>
                </div>
                <div class="col-3">
                  <small class="text-muted">Lucro Financiamento</small>
                  <div class="fw-bold text-warning">
                    {{ fmtBRL(total_lucro_financiamento_veiculos_novos) }}
                  </div>
                </div>
                <div class="col-3">
                  <small class="text-muted">Lucro Final</small>
                  <div class="fw-bold text-success">
                    {{ fmtBRL(total_lucro_final_veiculos_novos) }}
                  </div>
                </div>
              </div> -->

              <!-- Indicador de eficiência -->
              <div class="mt-3 p-2 rounded bg-light">
                <div class="d-flex justify-content-between align-items-center">
                  <span class="small"
                    ><i class="bi bi-star-fill text-warning"></i> Eficiência do
                    Segmento</span
                  >
                  <span class="fw-bold"
                    >{{ formatPercent(eficiencia_zero_km) }}%</span
                  >
                </div>
                <div class="progress" style="height: 4px">
                  <div
                    class="progress-bar bg-success-subtle"
                    :style="{ width: eficiencia_zero_km + '%' }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Usados -->
        <div class="col-md-6 p-1">
          <div class="card section-card h-100">
            <div class="card-header bg-white">
              <h5 class="mb-0">
                <i class="bi bi-car-front-fill me-2 text-warning"></i>
                Veículos Usados
              </h5>
            </div>
            <div class="card-body">
              <!-- Métricas principais -->
              <div class="row text-center mb-3">
                <div class="col-3">
                  <div class="stat-box p-2 bg-primary-subtle">
                    <i
                      class="bi bi-box-arrow-in-down  d-block mb-1"
                    ></i>
                    <h6 class="text-muted fw-bold">Passagens</h6>
                    <h3 class="mb-0">{{ total_passagem_usado }}</h3>
                    <div class="d-flex justify-content-center gap-2 small mt-1">
                      <h5 class="text-muted"
                        ><i class="bi bi-person-plus"></i>
                        {{ total_passagem_usado_novas }}</h5
                      >
                      <h5 class="text-muted"
                        ><i class="bi bi-arrow-return-left"></i>
                        {{ total_passagem_usado_retorno }}</h5
                      >
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="stat-box p-2 bg-secondary-subtle">
                    <i
                      class="bi bi-clock-history  d-block mb-1"
                    ></i>
                   <h6 class="text-muted fw-bold">Atendimento</h6>
                    <h3 class="mb-0">{{ total_em_atendimento_usados }}</h3>
                    <h6 class="text-muted"
                      >{{
                        formatPercent(total_em_atendimento_usados_porcentagem)
                      }}%</h6
                    >
                    <div class="d-flex justify-content-center gap-2 small mt-1">
                      <h5 class="text-muted"
                        ><i class="bi bi-person-plus m-2"></i
                        >{{ total_em_atendimento_usados_novos }}</h5
                      >
                      <h5 class="text-muted"
                        ><i class="bi bi-arrow-return-left m-2"></i
                        >{{ total_em_atendimento_usados_retorno }}</h5
                      >
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div
                    class="stat-box p-2 bg-danger-subtle"
                  >
                    <i class="bi bi-x-octagon  d-block mb-1"></i>
                   <h6 class="text-muted fw-bold">Vendas Perdidas</h6>
                    <h3 class="mb-0">
                      {{ total_vendas_perdidas_usados }}
                    </h3>
                    <h6 class="text-muted"
                      >{{
                        formatPercent(total_vendas_perdidas_usados_porcentagem)
                      }}%</h6
                    >
                    <div class="d-flex justify-content-center gap-2 small mt-1">
                      <h5 class="text-muted"
                        ><i class="bi bi-person-plus m-2"></i
                        >{{ total_vendas_perdidas_usados_novos }}</h5
                      >
                      <h5 class="text-muted"
                        ><i class="bi bi-arrow-return-left m-2"></i
                        >{{ total_vendas_perdidas_usados_retorno }}</h5
                      >
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="stat-box p-2 bg-success-subtle">
                    <i class="bi bi-check-lg d-block mb-1"></i>
                    <h6 class="text-muted fw-bold">Vendas Efetuadas</h6>
                    <h3 class="mb-0">
                      {{ total_vendas_finalizadas_usado }}
                    </h3>
                    <h6 class="text-muted"
                      >{{
                        formatPercent(
                          total_vendas_finalizadas_usado_porcentagem
                        )
                      }}%</h6
                    >
                    <div class="d-flex justify-content-center gap-2 small mt-1">
                      <h5 class="text-muted"
                        ><i class="bi bi-person-plus m-2"></i
                        >{{ total_vendas_finalizadas_usado_novos }}</h5
                      >
                      <h5 class="text-muted"
                        ><i class="bi bi-arrow-return-left m-2"></i
                        >{{ total_vendas_finalizadas_usado_retorno }}</h5
                      >
                    </div>
                  </div>
                </div>
              </div>

              <!-- Lucros do segmento -->
              <hr class="my-2" />
              <!-- <div class="row text-center">
                <div class="col-3">
                  <small class="text-muted">Lucro Operacional</small>
                  <div class="fw-bold text-primary">
                    {{ fmtBRL(total_lucro_operacional_veiculos_usados) }}
                  </div>
                </div>
                <div class="col-3">
                  <small class="text-muted">Lucro Gerencial</small>
                  <div class="fw-bold">
                    {{ fmtBRL(total_lucro_gerencial_veiculos_usados) }}
                  </div>
                </div>
                <div class="col-3">
                  <small class="text-muted">Lucro Financiamento</small>
                  <div class="fw-bold text-warning">
                    {{ fmtBRL(total_lucro_financiamento_veiculos_usados) }}
                  </div>
                </div>
                <div class="col-3">
                  <small class="text-muted">Lucro Final</small>
                  <div class="fw-bold text-success">
                    {{ fmtBRL(total_lucro_final_veiculos_usados) }}
                  </div>
                </div>
              </div> -->

              <!-- Indicador de eficiência -->
              <div class="mt-3 p-2 rounded bg-light">
                <div class="d-flex justify-content-between align-items-center">
                  <span class="small"
                    ><i class="bi bi-star-fill text-warning"></i> Eficiência do
                    Segmento</span
                  >
                  <span class="fw-bold"
                    >{{ formatPercent(eficiencia_usados) }}%</span
                  >
                </div>
                <div class="progress" style="height: 4px">
                  <div
                    class="progress-bar bg-success-subtle"
                    :style="{ width: eficiencia_usados + '%' }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- LINHA 4: RESULTADO FINANCEIRO CONSOLIDADO + GARGALO -->
      <!-- <div class="row mb-3">
        <div class="col-md-8 p-1">
          <div class="card section-card">
            <div class="card-header bg-white">
              <h5 class="mb-0">
                <i class="bi bi-cash-stack me-2"></i>
                Resultado Financeiro Consolidado
              </h5>
            </div>
            <div class="card-body">
              <div class="row text-center">
                <div class="col-md-3 col-6 mb-2">
                  <div class="financial-card p-2">
                    <i class="bi bi-graph-up text-primary fs-4"></i>
                    <p class="mb-0 small text-muted mt-1">Lucro Operacional</p>
                    <strong class="text-primary">{{
                      fmtBRL(total_lucro_operacional)
                    }}</strong>
                  </div>
                </div>
                <div class="col-md-3 col-6 mb-2">
                  <div class="financial-card p-2">
                    <i class="bi bi-bar-chart text-info fs-4"></i>
                    <p class="mb-0 small text-muted mt-1">Lucro Gerencial</p>
                    <strong>{{ fmtBRL(total_lucro_gerencial) }}</strong>
                  </div>
                </div>
                <div class="col-md-3 col-6 mb-2">
                  <div class="financial-card p-2">
                    <i class="bi bi-bank text-warning fs-4"></i>
                    <p class="mb-0 small text-muted mt-1">
                      Lucro Financiamento
                    </p>
                    <strong class="text-warning">{{
                      fmtBRL(total_lucro_financiamento)
                    }}</strong>
                  </div>
                </div>
                <div class="col-md-3 col-6 mb-2">
                  <div class="financial-card p-2 bg-success-light">
                    <i class="bi bi-trophy text-success fs-4"></i>
                    <p class="mb-0 small text-muted mt-1">Lucro Final</p>
                    <strong class="text-success">{{
                      fmtBRL(total_lucro_final)
                    }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 p-1">
          <div class="card alert-card h-100" :class="gargaloClass">
            <div class="card-body d-flex flex-column justify-content-center">
              <div class="d-flex align-items-center">
                <div class="alert-icon me-3">
                  <i class="bi fs-1" :class="gargaloIcon"></i>
                </div>
                <div>
                  <h5 class="mb-1">Gargalo Identificado</h5>
                  <p class="mb-0">{{ gargaloMessage }}</p>
                  <small class="text-muted mt-1 d-block">
                    <i class="bi bi-lightbulb"></i> Sugestão:
                    {{ sugestaoGargalo }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- LINHA 5: DETALHAMENTO POR LOJA (ACCORDION) -->
      <div class="row">
        <div class="col-12 p-1">
          <div class="card section-card">
            <div
              class="card-header bg-white d-flex justify-content-between align-items-center flex-wrap"
            >
              <h5 class="mb-0">
                <i class="bi bi-building me-2"></i>
                Desempenho por Loja
              </h5>
              <hr class="my-2" />
              <div class="d-flex gap-2">
                <button
                  class="btn btn-sm btn-outline-secondary"
                  @click="ordenarPorVendas"
                >
                  <i class="bi bi-sort-down"></i> Ordenar por Vendas
                </button>
                <button
                  class="btn btn-sm btn-outline-primary"
                  @click="expandirTodasLojas = !expandirTodasLojas"
                >
                  <i
                    :class="
                      expandirTodasLojas
                        ? 'bi bi-chevron-up'
                        : 'bi bi-chevron-down'
                    "
                  ></i>
                  {{ expandirTodasLojas ? "Recolher" : "Expandir" }}
                </button>
              </div>
            </div>
            <div class="card-body p-0">
              <div class="accordion" id="accordionLojas">
                <div
                  v-for="(item, index) in resumosPorEmpresaOrdenados"
                  :key="index"
                  class="accordion-item border-0 border-bottom"
                >
                  <div class="accordion-header">
                    <button
                      class="accordion-button collapsed py-3"
                      :class="{
                        show: expandirTodasLojas || activeIndex === index
                      }"
                      type="button"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#row-loja-' + index"
                      @click="toggleAccordion(index)"
                    >
                      <div
                        class="d-flex justify-content-between w-100 align-items-center me-3 flex-wrap"
                      >
                        <div class="d-flex align-items-center gap-3">
                          <i class="bi bi-building fs-5 text-primary"></i>
                          <strong>{{ item.nome }}</strong>
                          <span
                            :class="getPerformanceBadgeClass(item)"
                            class="badge"
                          >
                            {{ getPerformanceText(item) }}
                          </span>
                        </div>
                        <div class="d-flex gap-3 mt-2 mt-sm-0">
                          <span class="badge bg-primary-subtle"
                            >Zero:
                            {{ item.total_vendas_finalizadas_zero }}</span
                          >
                          <span class="badge bg-warning-subtle text-dark"
                            >Usados:
                            {{ item.total_vendas_finalizadas_usado }}</span
                          >
                          <span class="badge bg-success-subtle"
                            >Total:
                            {{
                              item.total_vendas_finalizadas_zero +
                              item.total_vendas_finalizadas_usado
                            }}</span
                          >
                          <span class="badge bg-info-subtle"
                            >Conv:
                            {{ formatPercentValue(item.taxa_conversao) }}</span
                          >
                        </div>
                      </div>
                    </button>
                  </div>
                  <div
                    :id="'row-loja-' + index"
                    class="accordion-collapse collapse"
                    :class="{
                      show: expandirTodasLojas || activeIndex === index
                    }"
                  >
                    <div class="accordion-body bg-light">
                      <div class="row">
                        <!-- Zero KM da loja -->
                        <div class="col-md-6 mb-3 mb-md-0">
                          <div class="card h-100">
                            <div class="card-header bg-white py-2">
                              <i class="bi bi-car-front text-primary me-1"></i>
                              Zero KM
                            </div>
                            <div class="card-body p-3">
                              <div class="row text-center g-2">
                                <div class="col-6">
                                  <div
                                    class="p-2 stat-box bg-primary-subtle rounded"
                                  >
                                    <i
                                      class="bi bi-box-arrow-in-down d-block mb-1"
                                    ></i>
                                    <h5 class="text-muted">
                                      <strong>Passagens</strong>
                                    </h5>
                                    <h3 class="fw-bold">
                                      {{ item.total_passagem_zero }}
                                    </h3>
                                    <div
                                      class="d-flex justify-content-center gap-2 small mt-1"
                                    >
                                      <h5 class="text-muted">
                                        <i class="bi bi-person-plus m-2"></i
                                        >{{ item.total_passagem_zero_novas }}
                                      </h5>
                                      <h5 class="text-muted">
                                        <i
                                          class="bi bi-arrow-return-left m-2"
                                        ></i
                                        >{{ item.total_passagem_zero_retorno }}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div
                                    class="p-2 stat-box bg-secondary-subtle rounded"
                                  >
                                    <i
                                      class="bi bi-clock-history d-block mb-1"
                                    ></i>
                                    <h5 class="text-muted">
                                      <strong>Em Atendimento</strong>
                                    </h5>
                                    <h3 class="fw-bold">
                                      {{ item.total_em_atendimento_zero }}
                                    </h3>
                                    <h6>
                                      {{
                                        formatPercent(
                                          item.total_em_atendimento_zero_porcentagem
                                        )
                                      }}%
                                    </h6>
                                    <div
                                      class="d-flex justify-content-center gap-2 small mt-1"
                                    >
                                      <h5 class="text-muted">
                                        <i class="bi bi-person-plus m-2"></i
                                        >{{
                                          item.total_em_atendimento_zero_novos
                                        }}
                                      </h5>
                                      <h5 class="text-muted ms-1">
                                        <i
                                          class="bi bi-arrow-return-left m-2"
                                        ></i
                                        >{{
                                          item.total_em_atendimento_zero_retorno
                                        }}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div
                                    class="p-2 stat-box bg-success-subtle rounded"
                                  >
                                    <i class="bi bi-check-lg d-block mb-1"></i>
                                    <h5 class="text-muted">
                                      <strong>Vendas</strong>
                                    </h5>
                                    <h3 class="fw-bold">
                                      {{ item.total_vendas_finalizadas_zero }}
                                    </h3>
                                    <h6>
                                      {{
                                        formatPercent(
                                          item.total_vendas_finalizadas_zero_porcentagem
                                        )
                                      }}%
                                    </h6>
                                    <div
                                      class="d-flex justify-content-center gap-2 small mt-1"
                                    >
                                      <h5 class="text-muted">
                                        <i class="bi bi-person-plus m-2"></i
                                        >{{
                                          item.total_vendas_finalizadas_zero_novos
                                        }}
                                      </h5>
                                      <h5 class="text-muted">
                                        <i
                                          class="bi bi-arrow-return-left m-2"
                                        ></i
                                        >{{
                                          item.total_vendas_finalizadas_zero_retorno
                                        }}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div
                                    class="p-2 stat-box bg-danger-subtle rounded"
                                  >
                                    <i class="bi bi-x-octagon d-block mb-1"></i>
                                    <h5 class="text-muted">
                                      <strong>Perdidas</strong>
                                    </h5>
                                    <h3 class="fw-bold">
                                      {{ item.total_vendas_perdidas_zero }}
                                    </h3>
                                    <h6 class="text-muted">
                                      {{
                                        formatPercent(
                                          item.total_vendas_perdidas_zero_porcentagem
                                        )
                                      }}%
                                    </h6>
                                    <div
                                      class="d-flex justify-content-center gap-2 small mt-1"
                                    >
                                      <h5 class="text-muted">
                                        <i class="bi bi-person-plus m-2"></i
                                        >{{
                                          item.total_vendas_perdidas_zero_novos
                                        }}
                                      </h5>
                                      <h5 class="text-muted">
                                        <i
                                          class="bi bi-arrow-return-left m-2"
                                        ></i
                                        >{{
                                          item.total_vendas_perdidas_zero_retorno
                                        }}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Usados da loja -->
                        <div class="col-md-6">
                          <div class="card h-100">
                            <div class="card-header bg-white py-2">
                              <i
                                class="bi bi-car-front-fill text-warning me-1"
                              ></i>
                              Usados
                            </div>
                            <div class="card-body p-3">
                              <div class="row text-center g-2">
                                <div class="col-6">
                                  <div
                                    class="p-2 stat-box bg-primary-subtle rounded"
                                  >
                                    <i
                                      class="bi bi-box-arrow-in-down d-block mb-1"
                                    ></i>
                                    <h5 class="text-muted">
                                      <strong>Passagens</strong>
                                    </h5>
                                    <h3 class="fw-bold">
                                      {{ item.total_passagem_usado }}
                                    </h3>
                                    <div
                                      class="d-flex justify-content-center gap-2 small mt-1"
                                    >
                                      <h5 class="text-muted">
                                        <i class="bi bi-person-plus m-2"></i
                                        >{{ item.total_passagem_usado_novas }}
                                      </h5>
                                      <h5 class="text-muted ms-1">
                                        <i
                                          class="bi bi-arrow-return-left m-2"
                                        ></i
                                        >{{ item.total_passagem_usado_retorno }}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div
                                    class="p-2 stat-box bg-secondary-subtle rounded"
                                  >
                                    <i
                                      class="bi bi-clock-history d-block mb-1"
                                    ></i>
                                    <h5 class="text-muted">
                                      <strong>Em Atendimento</strong>
                                    </h5>
                                    <h3 class="fw-bold">
                                      {{ item.total_em_atendimento_usados }}
                                    </h3>
                                    <h6>
                                      {{
                                        formatPercent(
                                          item.total_em_atendimento_usados_porcentagem
                                        )
                                      }}%
                                    </h6>
                                    <div
                                      class="d-flex justify-content-center gap-2 small mt-1"
                                    >
                                      <h5 class="text-muted">
                                        <i class="bi bi-person-plus m-2"></i
                                        >{{
                                          item.total_em_atendimento_usados_novos
                                        }}
                                      </h5>
                                      <h5 class="text-muted ms-1">
                                        <i
                                          class="bi bi-arrow-return-left m-2"
                                        ></i
                                        >{{
                                          item.total_em_atendimento_usados_retorno
                                        }}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div
                                    class="p-2 stat-box bg-success-subtle rounded"
                                  >
                                    <i class="bi bi-check-lg d-block mb-1"></i>
                                    <h5 class="text-muted">
                                      <strong>Vendas</strong>
                                    </h5>
                                    <h3 class="fw-bold">
                                      {{ item.total_vendas_finalizadas_usado }}
                                    </h3>
                                    <h6>
                                      {{
                                        formatPercent(
                                          item.total_vendas_finalizadas_usado_porcentagem
                                        )
                                      }}%
                                    </h6>
                                    <div
                                      class="d-flex justify-content-center gap-2 small mt-1"
                                    >
                                      <h5 class="text-muted">
                                        <i class="bi bi-person-plus m-2"></i
                                        >{{
                                          item.total_vendas_finalizadas_usado_novos
                                        }}
                                      </h5>
                                      <h5 class="text-muted">
                                        <i
                                          class="bi bi-arrow-return-left m-2"
                                        ></i
                                        >{{
                                          item.total_vendas_finalizadas_usado_retorno
                                        }}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div
                                    class="p-2 stat-box bg-danger-subtle rounded"
                                  >
                                    <i class="bi bi-x-octagon d-block mb-1"></i>
                                    <h5 class="text-muted">
                                      <strong>Perdidas</strong>
                                    </h5>
                                    <h3 class="fw-bold">
                                      {{ item.total_vendas_perdidas_usados }}
                                    </h3>
                                    <h6 class="text-muted">
                                      {{
                                        formatPercent(
                                          item.total_vendas_perdidas_usados_porcentagem
                                        )
                                      }}%
                                    </h6>
                                    <div
                                      class="d-flex justify-content-center gap-2 small mt-1"
                                    >
                                      <h5 class="text-muted">
                                        <i class="bi bi-person-plus m-2"></i
                                        >{{
                                          item.total_vendas_perdidas_usados_novos
                                        }}
                                      </h5>
                                      <h5 class="text-muted">
                                        <i
                                          class="bi bi-arrow-return-left m-2"
                                        ></i
                                        >{{
                                          item.total_vendas_perdidas_usados_retorno
                                        }}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <RodapeVue />
  </div>
</template>
<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import axios from "axios";
import TokenService from "../../services/token.service";
import jwt_decode from "jwt-decode";
import RodapeVue from "../../components/menu/Rodape.vue";
import NavgatorDk from "../../components/menu/NavgatorDk.vue";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
export default {
  components: {
    SidebarVue,
    NavgatorDk,
    RodapeVue
  },
  data() {
    return {
      activeIndex: null,
      lucro_operacional: "",
      lucro_gerencial: "",
      lucro_financiamento: "",
      lucro_final: "",

      total_passagem_zero: "",
      total_passagem_zero_retorno: "",
      total_passagem_zero_novas: "",
      total_em_atendimento_zero: "",
      total_em_atendimento_zero_novos: "",
      total_em_atendimento_zero_retorno: "",
      total_em_atendimento_zero_porcentagem: "",
      total_em_atendimento_zero_novos_porcentagem: "",
      total_em_atendimento_zero_retorno_porcentagem: "",

      total_vendas_perdidas_zero: "",
      total_vendas_perdidas_zero_porcentagem: "",
      total_vendas_perdidas_zero_novos: "",
      total_vendas_perdidas_zero_retorno: "",
      total_vendas_finalizadas_zero: "",
      total_vendas_finalizadas_zero_porcentagem: "",
      total_vendas_finalizadas_zero_novos: "",
      total_vendas_finalizadas_zero_novos_porcentagem: "",
      total_vendas_finalizadas_zero_retorno: "",
      total_vendas_finalizadas_zero_retorno_porcentagem: "",

      total_passagem_usado: "",
      total_passagem_usado_retorno: "",
      total_passagem_usado_novas: "",
      total_passagem_zero_novas_porcentagem: "",
      total_passagem_zero_retorno_porcentagem: "",
      total_em_atendimento_usados: "",
      total_em_atendimento_usados_porcentagem: "",
      total_em_atendimento_usados_novos: "",
      total_em_atendimento_usados_retorno: "",
      total_vendas_perdidas_usados: "",
      total_vendas_perdidas_usados_porcentagem: "",
      total_vendas_perdidas_usados_novos: "",
      total_vendas_perdidas_usados_retorno: "",
      total_vendas_perdidas_zero_novos_porcentagem: "",
      total_vendas_perdidas_zero_retorno_porcentagem: "",
      total_vendas_finalizadas_usado: "",
      total_vendas_finalizadas_usado_porcentagem: "",
      total_vendas_finalizadas_usado_novos: "",
      total_vendas_finalizadas_usado_novos_porcentagem: "",
      total_vendas_finalizadas_usado_retorno: "",
      total_vendas_finalizadas_usado_retorno_porcentagem: "",
      conversao_vendas: [],
      total_atendimentos: "",
      total_vendas: "",
      selectedFilter: "hoje",
      startDate: "",
      endDate: "",

      //Dados do Login
      user_id: "",
      company_id: "",
      lista_empresas: [],
      resumosPorEmpresa: [],
      selectedEmpresas: [],
      selectedEmpresasFiltradas: [],
      selectedEmpresasFiltradasIds: [],
      selectedTipoConversaoIds: [],
      selectedTipoVeiculoIds: [],
      marcarTodos: true,
      marcarTodosVeiculos: true,
      tipo_veiculo: [
        { nome: "Novos", value: 0 },
        { nome: "Usados", value: 1 }
      ],
      selectedTipoLoja: 1,
      selectedTipoVeiculo: [],
      marcarNovo: false,
      marcarUsado: false,
      referencia: "",
      filtroSelecionadoLabel: "Loja",
      selectedRelatorio: "venda_conversao",
      tipo_relatorio: "venda_conversao",
      vendas_perdidas: [],
      vendas_modelo: [],
      total_vendas_modelo: "",
      total_convesao_perc: 0.0,
      aproveitamento: "",
      eficiencia_comercial: "",
      gargalo: "",
      taxa_atendimento: "",
      taxa_conversao: "",
      taxa_perda: "",

      total_lucro_final_veiculos_novos: "",
      total_lucro_final_veiculos_usados: "",
      total_lucro_financiamento: "",
      total_lucro_financiamento_veiculos_novos: "",
      total_lucro_financiamento_veiculos_usados: "",
      total_lucro_gerencial: "",
      total_lucro_gerencial_veiculos_novos: "",
      total_lucro_gerencial_veiculos_usados: "",
      total_lucro_operacional: "",
      total_lucro_operacional_veiculos_novos: "",
      total_lucro_operacional_veiculos_usados: "",
      expandirTodasLojas: false,
      ordemPorVendas: false,
      composicaoChart: null,
      chartComposicao: null
    };
  },
  mounted() {
    this.getToken();
    this.getEmpresas();
    this.propostas_mes();
  },
  watch: {
    renderComposicaoChart() {
      const canvas = document.getElementById("composicaoChart");
      if (!canvas) return;

      const ctx = canvas.getContext("2d");

      // Destroi o gráfico anterior se existir
      if (this.composicaoChart) {
        this.composicaoChart.destroy();
      }

      // Cria o gráfico novo
      this.composicaoChart = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["Clientes Novos", "Clientes Retorno"],
          datasets: [
            {
              data: [
                this.percentual_novos_geral || 0,
                this.percentual_retorno_geral || 0
              ],
              backgroundColor: ["#28a745", "#ffc107"],
              borderWidth: 0,
              cutout: "70%"
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: {
                label: (context) => {
                  return `${context.label}: ${context.raw.toFixed(1)}%`;
                }
              }
            }
          }
        }
      });
    },

    marcarTodos(newVal) {
      if (newVal) {
        this.selectedEmpresas = this.lista_empresas.map((item) => item.id);
      } else {
        this.selectedEmpresas = [];
      }
    },
    selectedEmpresas(newVal) {
      if (this.marcarTodos && newVal.length !== this.lista_empresas.length) {
        this.marcarTodos = false;
      }
    },

    lista_empresas: {
      handler(newList) {
        this.selectedEmpresas = newList.map((item) => item.id);
        this.selectedTipoVeiculo = [0, 1];
        //this.relatorio_conversao_vendas();
        this.propostas_mes();
      },
      immediate: true // Para executar a função ao criar o componente
    }
  },
  created() {},
  computed: {
    taxa_atendimento_percent() {
      return this.taxa_atendimento * 100 + "%";
    },
    taxa_conversao_percent() {
      return this.taxa_conversao * 100 + "%";
    },
    percentual_novos_geral() {
      const totalNovos =
        this.total_passagem_zero_novas + this.total_passagem_usado_novas;
      const totalGeral = this.total_passagem_zero + this.total_passagem_usado;
      return totalGeral > 0 ? totalNovos / totalGeral : 0;
    },
    percentual_retorno_geral() {
      const totalRetorno =
        this.total_passagem_zero_retorno + this.total_passagem_usado_retorno;
      const totalGeral = this.total_passagem_zero + this.total_passagem_usado;
      return totalGeral > 0 ? totalRetorno / totalGeral : 0;
    },
    eficiencia_zero_km() {
      const vendas = this.total_vendas_finalizadas_zero;
      const passagens = this.total_passagem_zero;
      return passagens > 0 ? (vendas / passagens) * 100 : 0;
    },
    eficiencia_usados() {
      const vendas = this.total_vendas_finalizadas_usado;
      const passagens = this.total_passagem_usado;
      return passagens > 0 ? (vendas / passagens) * 100 : 0;
    },
    sugestaoGargalo() {
      if (this.gargalo === "BAIXO_ATENDIMENTO") {
        return "Aumentar equipe de vendas ou reduzir tempo de resposta";
      }
      if (this.taxa_perda > 0.45) {
        return "Revisar abordagem comercial e follow-up";
      }
      return "Monitorar indicadores diariamente";
    },
    resumosPorEmpresaOrdenados() {
      if (!this.ordemPorVendas) return this.resumosPorEmpresa;
      console.log("Resumo", this.resumosPorEmpresa);
      return [...this.resumosPorEmpresa].sort((a, b) => {
        const totalA =
          a.total_vendas_finalizadas_zero + a.total_vendas_finalizadas_usado;
        const totalB =
          b.total_vendas_finalizadas_zero + b.total_vendas_finalizadas_usado;
        return totalB - totalA;
      });
    },

    gargaloClass() {
      const gargaloMap = {
        BAIXO_ATENDIMENTO: "alert-warning",
        ALTA_PERDA: "alert-danger",
        OPORTUNIDADE: "alert-info"
      };
      return gargaloMap[this.gargalo] || "alert-secondary";
    },
    gargaloIcon() {
      const iconMap = {
        BAIXO_ATENDIMENTO: "bi-clock-history",
        ALTA_PERDA: "bi-exclamation-triangle",
        OPORTUNIDADE: "bi-lightbulb"
      };
      return iconMap[this.gargalo] || "bi-info-circle";
    },
    gargaloMessage() {
      const messageMap = {
        BAIXO_ATENDIMENTO:
          "Baixo índice de atendimento. Necessário aumentar capacidade de atendimento.",
        ALTA_PERDA: "Alta taxa de perda de vendas. Revisar processo comercial.",
        OPORTUNIDADE:
          "Oportunidade de melhoria identificada. Acompanhar indicadores."
      };
      return (
        messageMap[this.gargalo] || "Monitorar indicadores de performance."
      );
    }
  },
  methods: {
    renderComposicaoChart() {
      const canvas = document.getElementById("composicaoChart");
      if (!canvas) return;

      const ctx = canvas.getContext("2d");

      // 🔥 destrói o anterior
      if (this.chartComposicao) {
        this.chartComposicao.destroy();
      }

      this.chartComposicao = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["Novos", "Retorno"],
          datasets: [
            {
              data: [
                this.percentual_novos_geral || 0,
                this.percentual_retorno_geral || 0
              ],
              backgroundColor: ["#28a745", "#ffc107"]
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false, // 🔥 permite crescer

          cutout: "65%", // 🔥 donut mais "grosso" (antes era 70%)

          plugins: {
            legend: {
              display: false // ❌ remove legenda
            }
          }
        }
      });
    },
    ordenarPorVendas() {
      this.ordemPorVendas = !this.ordemPorVendas;
    },
    getPerformanceBadgeClass(item) {
      const totalVendas =
        item.total_vendas_finalizadas_zero +
        item.total_vendas_finalizadas_usado;
      if (totalVendas > 10) return "bg-success-subtle";
      if (totalVendas > 5) return "bg-warning-subtle text-dark";
      return "bg-secondary-subtle";
    },
    getPerformanceText(item) {
      const totalVendas =
        item.total_vendas_finalizadas_zero +
        item.total_vendas_finalizadas_usado;
      if (totalVendas > 10) return "🔥 Destaque";
      if (totalVendas > 5) return "📈 Regular";
      return "⚠️ Atenção";
    },
    formatPercent(value) {
      if (!value && value !== 0) return "0";
      return `${value.toFixed(1)}`;
    },
    formatPercentValue(value) {
      if (!value && value !== 0) return "0%";
      return `${value.toFixed(2) * 100}%`;
    },
    formatCurrency(value) {
      if (!value && value !== 0) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(value);
    },
    fmtBRL(n) {
      const value = Number(n || 0);
      const formatCompact = (val, suffix) => {
        const num = val.toFixed(2);
        // remove .00 quando não precisa
        const clean = num.endsWith(".00") ? num.slice(0, -3) : num;
        return `R$ ${clean}${suffix}`;
      };

      if (value >= 1000000000) return formatCompact(value / 1000000000, "B");
      if (value >= 1000000) return formatCompact(value / 1000000, "M");
      if (value >= 1000) return formatCompact(value / 1000, "K");

      return value.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    toggleAccordion(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    getToken() {
      const accessToken = TokenService.getLocalAccessToken();

      // Obter o token de atualização (refresh token)
      TokenService.getLocalRefreshToken();

      // Obter o usuário completo (incluindo os tokens) se necessário
      TokenService.getUser();

      const decodedToken = jwt_decode(accessToken);
      console.log(decodedToken);
      this.company_id = decodedToken.company;
      this.user_id = decodedToken.id;
    },
    getRequestParams(
      EmpresasSelecionadas,
      page,
      pageSize,
      empresa_id,
      usuario_id,
      data_ini,
      data_fim,
      referencia
    ) {
      let params = {};
      if (EmpresasSelecionadas) {
        params["ids"] = EmpresasSelecionadas;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (empresa_id) {
        params["empresa_id"] = empresa_id;
      }
      if (usuario_id) {
        params["usuario_id"] = usuario_id;
      }
      if (data_ini) {
        params["data_ini"] = data_ini;
      }
      if (data_fim) {
        params["data_fim"] = data_fim;
      }
      if (referencia) {
        params["referencia"] = referencia;
      }

      return params;
    },

    filtarRelatorios() {
      if (this.selectedFilter === "hoje") {
        this.referencia = this.selectedFilter;
      } else if (this.selectedFilter === "ontem") {
        this.referencia = this.selectedFilter;
      } else if (this.selectedFilter === "mes_atual") {
        this.referencia = this.selectedFilter;
      } else if (this.selectedFilter === "mes_anterior") {
        this.referencia = this.selectedFilter;
      }
    },

    async propostas_mes() {
      const params = {
        empresa_id: this.company_id,
        user_id: this.user_id,
        data_ini: this.startDate,
        data_fim: this.endDate,
        referencia: this.selectedFilter,
        empresas: this.selectedEmpresas
      };

      await axios
        .get(`${process.env.VUE_APP_API_URL}propostas_mes`, {
          params
        })
        .then((response) => {
          console.log("Resposta filtrada por datas");
          console.log(response.data);
          const res = response.data;

          this.aproveitamento = response.data.aproveitamento;
          this.eficiencia_comercial = response.data.eficiencia_comercial;
          this.gargalo = response.data.gargalo;
          this.taxa_atendimento = response.data.taxa_atendimento;
          this.taxa_conversao = response.data.taxa_conversao;
          this.taxa_perda = response.data.taxa_perda;
          this.total_passagem_zero_novas_porcentagem =
            response.data.total_passagem_zero_novas_porcentagem;
          this.total_passagem_zero_retorno_porcentagem =
            response.data.total_passagem_zero_retorno_porcentagem;

          this.total_em_atendimento_zero_novos =
            response.data.total_em_atendimento_zero_novos;
          this.total_em_atendimento_zero_retorno =
            response.data.total_em_atendimento_zero_retorno;
          this.total_em_atendimento_zero_novos_porcentagem =
            response.data.total_em_atendimento_zero_novos_porcentagem;
          this.total_em_atendimento_zero_retorno_porcentagem =
            response.data.total_em_atendimento_zero_retorno_porcentagem;

          this.total_vendas_perdidas_zero_novos =
            response.data.total_vendas_perdidas_zero_novos;
          this.total_vendas_perdidas_zero_retorno =
            response.data.total_vendas_perdidas_zero_retorno;
          this.total_vendas_perdidas_zero_novos_porcentagem =
            response.data.total_vendas_perdidas_zero_novos_porcentagem;
          this.total_vendas_perdidas_zero_retorno_porcentagem =
            response.data.total_vendas_perdidas_zero_retorno_porcentagem;

          this.total_em_atendimento_usados_novos =
            response.data.total_em_atendimento_usados_novos;
          this.total_em_atendimento_usados_retorno =
            response.data.total_em_atendimento_usados_retorno;

          this.total_vendas_perdidas_usados_novos =
            response.data.total_vendas_perdidas_usados_novos;
          this.total_vendas_perdidas_usados_retorno =
            response.data.total_vendas_perdidas_usados_retorno;

          this.total_lucro_final = response.data.total_lucro_final;
          this.total_lucro_final_veiculos_novos =
            response.data.total_lucro_final_veiculos_novos;
          this.total_lucro_final_veiculos_usados =
            response.data.total_lucro_final_veiculos_usados;
          this.total_lucro_financiamento =
            response.data.total_lucro_financiamento;
          this.total_lucro_financiamento_veiculos_novos =
            response.data.total_lucro_financiamento_veiculos_novos;
          this.total_lucro_financiamento_veiculos_usados =
            response.data.total_lucro_financiamento_veiculos_usados;
          this.total_lucro_gerencial = response.data.total_lucro_gerencial;
          this.total_lucro_gerencial_veiculos_novos =
            response.data.total_lucro_gerencial_veiculos_novos;
          this.total_lucro_gerencial_veiculos_usados =
            response.data.total_lucro_gerencial_veiculos_usados;
          this.total_lucro_operacional = response.data.total_lucro_operacional;
          this.total_lucro_operacional_veiculos_novos =
            response.data.total_lucro_gerencial_veiculos_novos;
          this.total_lucro_operacional_veiculos_usados =
            response.data.total_lucro_operacional_veiculos_usados;

          //Restultado operacional
          this.lucro_operacional = JSON.parse(
            JSON.stringify(res["total_lucro_operacional_veiculos_usados"])
          );
          this.lucro_gerencial = JSON.parse(
            JSON.stringify(res["total_lucro_gerencial_veiculos_usados"])
          );
          this.lucro_financiamento = JSON.parse(
            JSON.stringify(res["total_lucro_financiamento_veiculos_usados"])
          );
          this.lucro_final = JSON.parse(
            JSON.stringify(res["total_lucro_final_veiculos_usados"])
          );

          this.total_passagem_zero = JSON.parse(
            JSON.stringify(res["total_passagem_zero"])
          );
          this.total_passagem_zero_retorno = JSON.parse(
            JSON.stringify(res["total_passagem_zero_retorno"])
          );
          this.total_passagem_zero_novas = JSON.parse(
            JSON.stringify(res["total_passagem_zero_novas"])
          );
          this.total_em_atendimento_zero = JSON.parse(
            JSON.stringify(res["total_em_atendimento_zero"])
          );

          this.total_em_atendimento_zero_porcentagem = JSON.parse(
            JSON.stringify(res["total_em_atendimento_zero_porcentagem"])
          );
          this.total_vendas_perdidas_zero = JSON.parse(
            JSON.stringify(res["total_vendas_perdidas_zero"])
          );
          this.total_vendas_perdidas_zero_porcentagem = JSON.parse(
            JSON.stringify(res["total_vendas_perdidas_zero_porcentagem"])
          );
          this.total_vendas_finalizadas_zero = JSON.parse(
            JSON.stringify(res["total_vendas_finalizadas_zero"])
          );
          this.total_vendas_finalizadas_zero_porcentagem = JSON.parse(
            JSON.stringify(res["total_vendas_finalizadas_zero_porcentagem"])
          );

          this.total_vendas_finalizadas_zero_novos = JSON.parse(
            JSON.stringify(res["total_vendas_finalizadas_zero_novos"])
          );
          this.total_vendas_finalizadas_zero_novos_porcentagem = JSON.parse(
            JSON.stringify(
              res["total_vendas_finalizadas_zero_novos_porcentagem"]
            )
          );
          this.total_vendas_finalizadas_zero_retorno = JSON.parse(
            JSON.stringify(res["total_vendas_finalizadas_zero_retorno"])
          );
          this.total_vendas_finalizadas_zero_retorno_porcentagem = JSON.parse(
            JSON.stringify(
              res["total_vendas_finalizadas_zero_retorno_porcentagem"]
            )
          );

          this.total_passagem_usado = JSON.parse(
            JSON.stringify(res["total_passagem_usado"])
          );
          this.total_passagem_usado_retorno = JSON.parse(
            JSON.stringify(res["total_passagem_usado_retorno"])
          );
          this.total_passagem_usado_novas = JSON.parse(
            JSON.stringify(res["total_passagem_usado_novas"])
          );
          this.total_em_atendimento_usados = JSON.parse(
            JSON.stringify(res["total_em_atendimento_usados"])
          );
          this.total_em_atendimento_usados_porcentagem = JSON.parse(
            JSON.stringify(res["total_em_atendimento_usados_porcentagem"])
          );
          this.total_vendas_perdidas_usados = JSON.parse(
            JSON.stringify(res["total_vendas_perdidas_usados"])
          );
          this.total_vendas_perdidas_usados_porcentagem = JSON.parse(
            JSON.stringify(res["total_vendas_perdidas_usados_porcentagem"])
          );
          this.total_vendas_finalizadas_usado = JSON.parse(
            JSON.stringify(res["total_vendas_finalizadas_usado"])
          );
          this.total_vendas_finalizadas_usado_porcentagem = JSON.parse(
            JSON.stringify(res["total_vendas_finalizadas_usado_porcentagem"])
          );
          this.total_vendas_finalizadas_usado_novos = JSON.parse(
            JSON.stringify(res["total_vendas_finalizadas_usado_novos"])
          );
          this.total_vendas_finalizadas_usado_novos_porcentagem = JSON.parse(
            JSON.stringify(
              res["total_vendas_finalizadas_usado_novos_porcentagem"]
            )
          );
          this.total_vendas_finalizadas_usado_retorno = JSON.parse(
            JSON.stringify(res["total_vendas_finalizadas_usado_retorno"])
          );
          this.total_vendas_finalizadas_usado_retorno_porcentagem = JSON.parse(
            JSON.stringify(
              res["total_vendas_finalizadas_usado_retorno_porcentagem"]
            )
          );

          this.propostas_mes_empresa();
          this.resumo_gerencial();
          this.$nextTick(() => {
            this.renderComposicaoChart();
          });
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 400) {
            this.abrir_modal = true;
            this.msg = error.response.data.message;
          }
        });
    },
    async propostas_mes_empresa() {
      const params = {
        empresa_id: this.company_id,
        user_id: this.user_id,
        data_ini: this.startDate,
        data_fim: this.endDate,
        referencia: this.selectedFilter,
        empresas: this.selectedEmpresas
      };
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}propostas_mes_empresa`,
          {
            params
          }
        );
        const resumos = response.data;
        console.log("Resumos por empresa");
        console.log(resumos);

        // Criar um objeto para armazenar os resumos por ID da empresa
        const resumosPorEmpresa = {};

        // Iterar sobre o array de resumos e organizar por ID da empresa
        resumos.forEach((resumo) => {
          const empresaId = resumo.id_empresa;
          resumosPorEmpresa[empresaId] = resumo;
          // this.resumosPorEmpresa = resumosPorEmpresa[empresaId];
        });

        this.resumosPorEmpresa = resumos;
        // Agora resumosPorEmpresa contém os resumos organizados por ID da empresa
        console.log(this.resumosPorEmpresa);

        // Você pode acessar os resumos de uma empresa específica assim:
        const empresaIdDesejado = 16;
        const resumoDaEmpresaDesejada = resumosPorEmpresa[empresaIdDesejado];

        console.log(empresaIdDesejado);
        console.log(resumoDaEmpresaDesejada);
      } catch (error) {
        if (error.response.status === 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }

      // await axios.get(`${process.env.VUE_APP_API_URL}propostas_mes_empresa`, {
      //     params
      // })
      //     .then(response => {
      //         console.log(response.data)
      //         const res = response.data

      //         //Restultado operacional
      //         this.lucro_operacional = JSON.parse(JSON.stringify(res['total_lucro_operacional_veiculos_usados']));
      //         this.lucro_gerencial = JSON.parse(JSON.stringify(res['total_lucro_gerencial_veiculos_usados']));
      //         this.lucro_financiamento = JSON.parse(JSON.stringify(res['total_lucro_financiamento_veiculos_usados']));
      //         this.lucro_final = JSON.parse(JSON.stringify(res['total_lucro_final_veiculos_usados']));

      //         this.total_passagem_zero = JSON.parse(JSON.stringify(res['total_passagem_zero']));
      //         this.total_passagem_zero_retorno = JSON.parse(JSON.stringify(res['total_passagem_zero_retorno']));
      //         this.total_passagem_zero_novas = JSON.parse(JSON.stringify(res['total_passagem_zero_novas']));
      //         this.total_em_atendimento_zero = JSON.parse(JSON.stringify(res['total_em_atendimento_zero']));
      //         this.total_em_atendimento_zero_porcentagem = JSON.parse(JSON.stringify(res['total_em_atendimento_zero_porcentagem'])).toFixed(2);
      //         this.total_vendas_perdidas_zero = JSON.parse(JSON.stringify(res['total_vendas_perdidas_zero']));
      //         this.total_vendas_perdidas_zero_porcentagem = JSON.parse(JSON.stringify(res['total_vendas_perdidas_zero_porcentagem'])).toFixed(2);
      //         this.total_vendas_finalizadas_zero = JSON.parse(JSON.stringify(res['total_vendas_finalizadas_zero']));
      //         this.total_vendas_finalizadas_zero_porcentagem = JSON.parse(JSON.stringify(res['total_vendas_finalizadas_zero_porcentagem'])).toFixed(2);

      //         this.total_vendas_finalizadas_zero_novos = JSON.parse(JSON.stringify(res['total_vendas_finalizadas_zero_novos']));
      //         this.total_vendas_finalizadas_zero_novos_porcentagem = JSON.parse(JSON.stringify(res['total_vendas_finalizadas_zero_novos_porcentagem'])).toFixed(2);
      //         this.total_vendas_finalizadas_zero_retorno = JSON.parse(JSON.stringify(res['total_vendas_finalizadas_zero_retorno']));
      //         this.total_vendas_finalizadas_zero_retorno_porcentagem = JSON.parse(JSON.stringify(res['total_vendas_finalizadas_zero_retorno_porcentagem'])).toFixed(2);

      //         this.total_passagem_usado = JSON.parse(JSON.stringify(res['total_passagem_usado']));
      //         this.total_passagem_usado_retorno = JSON.parse(JSON.stringify(res['total_passagem_usado_retorno']));
      //         this.total_passagem_usado_novas = JSON.parse(JSON.stringify(res['total_passagem_usado_novas']));
      //         this.total_em_atendimento_usados = JSON.parse(JSON.stringify(res['total_em_atendimento_usados']));
      //         this.total_em_atendimento_usados_porcentagem = JSON.parse(JSON.stringify(res['total_em_atendimento_usados_porcentagem'])).toFixed(2);
      //         this.total_vendas_perdidas_usados = JSON.parse(JSON.stringify(res['total_vendas_perdidas_usados']));
      //         this.total_vendas_perdidas_usados_porcentagem = JSON.parse(JSON.stringify(res['total_vendas_perdidas_usados_porcentagem'])).toFixed(2);
      //         this.total_vendas_finalizadas_usado = JSON.parse(JSON.stringify(res['total_vendas_finalizadas_usado']));
      //         this.total_vendas_finalizadas_usado_porcentagem = JSON.parse(JSON.stringify(res['total_vendas_finalizadas_usado_porcentagem'])).toFixed(2);
      //         this.total_vendas_finalizadas_usado_novos = JSON.parse(JSON.stringify(res['total_vendas_finalizadas_usado_novos']));
      //         this.total_vendas_finalizadas_usado_novos_porcentagem = JSON.parse(JSON.stringify(res['total_vendas_finalizadas_usado_novos_porcentagem'])).toFixed(2);
      //         this.total_vendas_finalizadas_usado_retorno = JSON.parse(JSON.stringify(res['total_vendas_finalizadas_usado_retorno']));
      //         this.total_vendas_finalizadas_usado_retorno_porcentagem = JSON.parse(JSON.stringify(res['total_vendas_finalizadas_usado_retorno_porcentagem'])).toFixed(2);

      //     })
      //     .catch(error => {
      //         if (error.response.status == 400) {
      //             this.abrir_modal = true;
      //             this.msg = error.response.data.message;
      //         }
      //     })
    },

    async getEmpresas() {
      console.log("Buscando Empresas");
      const user_id = this.user_id;
      // Limpar o array antes de buscar novas empresas

      await axios
        .get(`${process.env.VUE_APP_API_URL}user_empresas`, {
          params: { id: user_id }
        })
        .then((response) => {
          console.log("Dados obtidos", response);
          // Filtrar as empresas com base no selectedTipoLoja
          this.lista_empresas = response.data.filter((empresa) => {
            if (this.selectedTipoLoja == 1) {
              console.log("Quatro Rodas");

              return empresa.tipo_empresa === 1;
            } else if (this.selectedTipoLoja == 2) {
              console.log("Duas Rodas");
              return empresa.tipo_empresa === 2;
            }

            // Se não for 1 nem 2, não filtra

            return true;
          });
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.abrir_modal = true;
            this.msg = error.response.data.message;
          }
        });
    },
    async resumo_gerencial() {
      console.log("Aqui Resumo");
      await fetch(`${process.env.VUE_APP_API_URL}taxas/resumo_gerencial`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          empresas: this.selectedEmpresas
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          return data.json();
        })
        .then((resposta) => {
          if (resposta["tipo_veiculo"] == "NOVO") {
            this.Lucro_Bruto = resposta["Lucro_Bruto_Zero"];
            this.Lucro_Operacional = resposta["Lucro_Operacional_Zero"];
            this.Lucro_liquido = resposta["Lucro_liquido_Zero"];
          }
          if (resposta["tipo_veiculo"] == "USADO") {
            this.Lucro_Bruto = resposta["Lucro_Bruto"];
            this.Lucro_Operacional = resposta["Lucro_Operacional"];
            this.Lucro_liquido = resposta["Lucro_liquido"];
          }
          (this.Valor_Sugerido = resposta["Valor_Sugerido"]),
            (this.Valor_Custo_variaveis = resposta["Valor_Custo_variaveis"]),
            (this.Valor_Itens_Acessorios = resposta["Valor_Itens_Acessorios"]);
          this.Valor_Total_Venda = resposta["Valor_Total_Venda"];
          this.Valor_Avaliado = resposta["Valor_Avaliado"];
          this.Valor_Itens_Avaliacao_db = resposta["Valor_Itens_Avaliacao_db"];
          this.Valor_Itens_Avaliacao_cr = resposta["Valor_Itens_Avaliacao_cr"];
          this.Valor_Avaliacao_Final = resposta["Valor_Avaliacao_Final"];

          this.Valor_Resultado_Financiamento =
            resposta["Valor_Resultado_Financiamento"];

          this.Valor_Entrada = resposta["Valor_Entrada"];
          this.Valor_Financiado = resposta["Valor_Financiado"];
          this.Quantidade_Meses = resposta["Quantidade_Meses"];

          this.Valor_Entrada_1 = resposta["Valor_Entrada_1"];
          this.Valor_Financiado_1 = resposta["Valor_Financiado_1"];
          this.Quantidade_Meses_1 = resposta["Quantidade_Meses_1"];

          this.Valor_Entrada_2 = resposta["Valor_Entrada_2"];
          this.Valor_Financiado_2 = resposta["Valor_Financiado_2"];
          this.Quantidade_Meses_2 = resposta["Quantidade_Meses_2"];

          this.Valor_Entrada_3 = resposta["Valor_Entrada_3"];
          this.Valor_Financiado_3 = resposta["Valor_Financiado_3"];
          this.Quantidade_Meses_3 = resposta["Quantidade_Meses_3"];

          this.Pmt = resposta["Pmt"];
          this.parcela_1_1 = resposta["Pmt_1"];
          this.parcela_2_1 = resposta["Pmt_2"];
          this.parcela_3_1 = resposta["Pmt_3"];
          this.parcela_1_2 = resposta["Pmt_4"];
          this.parcela_2_2 = resposta["Pmt_5"];
          this.parcela_3_2 = resposta["Pmt_6"];
          this.parcela_1_3 = resposta["Pmt_7"];
          this.parcela_2_3 = resposta["Pmt_8"];
          this.parcela_3_3 = resposta["Pmt_9"];
          if (resposta["Parcela1"]) {
            console.log("Existe uma parcela");
            this.parcela_1 = resposta["Parcela1"];
            this.bloquear_entrada = true;
          }

          this.parcela_2 = resposta["Parcela2"];

          this.parcela_3 = resposta["Parcela3"];

          let v_entrada_1 = resposta["Entrada1"];
          let v_entrada_2 = resposta["Entrada2"];
          let v_entrada_3 = resposta["Entrada3"];
          this.entrada_1 = this.currency(v_entrada_1);
          this.entrada_2 = this.currency(v_entrada_2);
          this.entrada_3 = this.currency(v_entrada_3);
          this.adicional = resposta["Valor_Adicional"];
          this.desconto = resposta["Valor_Desconto"];

          if (resposta["incluir_acessorios"] == "1") {
            console.log(
              "Somar Acessorios ---------------------------------------------------------------------------"
            );
            this.incluir_acessorios = true;
          } else {
            this.incluir_acessorios = false;
            console.log(
              "Não Somar Acessorios ---------------------------------------------------------------------------"
            );
          }
          if (resposta["Valor_Resultado_Financiamento"] != "") {
            this.btn_gerar_menu = false;
            this.btn_1 = false;
            this.btn_finalizar_venda = false;
          }

          console.log(resposta);
        });
    },

    currency(number) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      }).format(number);
    }
  }
};
</script>
<style scoped>
.dashboard-bi {
  padding: 24px;
  background: #f4f6f9;
  min-height: 100vh;
}

/* KPI CARDS */
.kpi-card {
  border: none;
  border-radius: 18px;
  transition: all 0.25s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.kpi-card:hover {
  transform: translateY(-6px) scale(1.01);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.12);
}

/* glow lateral */
.kpi-card::after {
  content: "";
  position: absolute;
  right: -40px;
  top: -40px;
  width: 120px;
  height: 120px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

/* GRADIENTES MAIS FORTES */
.kpi-primary {
  background: linear-gradient(135deg, #f5f3ff, #ede9fe);
  color: #5b21b6;
}

.kpi-success {
  background: linear-gradient(135deg, #f0fdf4, #e4f5e9);
  color: #166534;
}

.kpi-warning {
  background: linear-gradient(135deg, #fff7ed, #ffefdb);
  color: #b45309;
}

.kpi-info {
  background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
  color: #0369a1;
}

/* ÍCONE KPI */
.kpi-icon {
  font-size: 2rem;
  opacity: 0.15;
  position: absolute;
  right: 20px;
  bottom: 5px;
}

/* TEXTOS KPI */
.kpi-card h2 {
  font-size: 28px;
  font-weight: 800;
}

.kpi-card small {
  opacity: 0.8;
}

/* SECTION CARD */
.section-card {
  border: none;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.05);
}

.section-card .card-header {
  border-bottom: none;
  padding: 18px 22px;
  font-weight: 600;
  background: #f9fafb;
}

/* STAT CARDS */
.stat-card {
  border: none;
  border-radius: 14px;
  transition: all 0.25s;
  cursor: pointer;
  background: linear-gradient(135deg, #eef2ff, #e0e7ff);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.04);
  height: 220px;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
}

/* ÍCONE STAT */
.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  font-size: 1.6rem;
  margin-bottom: 6px;
}

/* CORES SUAVES MAIS PREMIUM */
.bg-primary-light {
  background: rgba(79, 70, 229, 0.1);
  color: #4f46e5;
}

.bg-success-light {
  background: rgba(22, 163, 74, 0.1);
  color: #16a34a;
}

.bg-warning-light {
  background: rgba(249, 115, 22, 0.1);
  color: #f97316;
}

.bg-danger-light {
  background: rgba(220, 38, 38, 0.1);
  color: #dc2626;
}

.bg-info-light {
  background: rgba(14, 165, 233, 0.1);
  color: #0ea5e9;
}

/* NUMEROS GRANDES */
.stat-card h3 {
  font-size: 26px;
  font-weight: 800;
}

/* DETAILS */
.stat-details {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #e5e7eb;
  font-size: 12px;
  color: #6b7280;
}

/* PROFIT */
.profit-card {
  border-radius: 14px;
  transition: 0.25s;
  background: linear-gradient(135deg, #eef2ff, #e0e7ff);
}

.profit-card:hover {
  transform: translateY(-4px);
}

.profit-total {
  background: linear-gradient(135deg, #4338ca, #6366f1);
  color: white;
}

.profit-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  font-size: 1.6rem;
}

/* ALERTA */
.alert-card {
  border-radius: 14px;
  padding: 4px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
}

.alert-icon {
  font-size: 2.2rem;
}

/* INFO CARD */
.info-card {
  background: linear-gradient(135deg, #4f46e5, #6366f1);
  border-radius: 14px;
}

.info-card .progress {
  background-color: rgba(255, 255, 255, 0.2);
}
.text-operacional {
  font-size: 29px !important;
}
.compact-profit strong {
  font-size: 0.85rem;
}

.segment-stat h4 {
  font-size: 1.1rem;
}

.accordion-button .badge {
  font-size: 0.65rem;
}
/* NOVOS ESTILOS */
.kpi-card-v2 {
  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
  border-radius: 16px;
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
}

.kpi-card-v2:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.kpi-icon-circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg-primary-light {
  background: rgba(13, 110, 253, 0.1);
}
.bg-success-light {
  background: rgba(25, 135, 84, 0.1);
}
.bg-danger-light {
  background: rgba(220, 53, 69, 0.1);
}
.bg-warning-light {
  background: rgba(255, 193, 7, 0.1);
}

.stat-box {
  background: #f8f9fa;
  border-radius: 12px;
  transition: all 0.2s;
  height: 150px;
}

.stat-box:hover {
  background: #e9ecef;
  transform: scale(1.02);
}

.financial-card {
  background: #f8f9fa;
  border-radius: 12px;
  transition: all 0.2s;
}

.financial-card:hover {
  background: #e9ecef;
}

.composicao-circle svg {
  transform: rotate(-90deg);
}

.bg-danger-light {
  background: rgba(220, 53, 69, 0.15);
  border: 1px solid rgba(220, 53, 69, 0.3);
}

.accordion-button:not(.collapsed) {
  background: linear-gradient(90deg, #e7f1ff 0%, #fff 100%);
}

/* MOBILE */
@media (max-width: 768px) {
  .dashboard-bi {
    padding: 12px;
  }

  .kpi-card h2 {
    font-size: 20px;
  }

  .stat-card h3 {
    font-size: 20px;
  }
  .compact-profit strong {
    font-size: 0.85rem;
  }

  .segment-stat h4 {
    font-size: 1.1rem;
  }

  .accordion-button .badge {
    font-size: 0.65rem;
  }
  .kpi-card-v2 {
    margin-bottom: 12px;
  }

  .stat-box h4 {
    font-size: 1.2rem;
  }

  .stat-box .small {
    font-size: 0.7rem;
  }
}
</style>
